import { create } from "zustand";

const useBannersCategoryDetailData = create((set) => ({
  selectedData: null,
  renewData: false,
  setSelectedData: (data) => set(() => ({ selectedData: data })),
  setRenewData: (bool) => set(() => ({ renewData: bool })),
}));

export default useBannersCategoryDetailData;
